module.exports = __webpack_public_path__ + "media/images/checkbox-filled-in-cfb8090295338c7c589dba66fe7baef8.png";